import React from "react";
import { NonContractedWorkshopFormData } from "../../interfaces/altair";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
import "../shared/popup-card.scss";

interface NonContractedWorkshopFormProps {
  visible: boolean;
  form: NonContractedWorkshopFormData;
  onChange: (form: NonContractedWorkshopFormData) => void;
  onSubmit: () => void;
}

export const NonContractedWorkshopForm: React.FC<NonContractedWorkshopFormProps> = ({
  visible,
  form,
  onChange,
  onSubmit,
}) => {
  useOverlayPopupOpen(visible);
  if (!visible) return null;

  const updateField = (field: keyof NonContractedWorkshopFormData, value: string) =>
    onChange({ ...form, [field]: value });

  return (
    <div className="popup-overlay">
      <div className="popup-card popup-card--wide">
        <h3 className="popup-title">بيانات مركز الإصلاح</h3>
        <div className="popup-form-fields">
          <input
            type="text"
            placeholder="اسم مركز الخدمة *"
            value={form.workshopName}
            onChange={(e) => updateField("workshopName", e.target.value)}
            className="popup-input popup-input--rect"
          />
          <div className="popup-form-row">
            <input
              type="text"
              placeholder="المدينة"
              value={form.city}
              onChange={(e) => updateField("city", e.target.value)}
              className="popup-input popup-input--rect"
              style={{ marginBottom: 0, flex: 1 }}
            />
            <input
              type="text"
              placeholder="المنطقة"
              value={form.area}
              onChange={(e) => updateField("area", e.target.value)}
              className="popup-input popup-input--rect"
              style={{ marginBottom: 0, flex: 1 }}
            />
          </div>
          <input
            type="text"
            placeholder="العنوان"
            value={form.workshopAddress}
            onChange={(e) => updateField("workshopAddress", e.target.value)}
            className="popup-input popup-input--rect"
          />
          <input
            type="text"
            placeholder="اسم المسؤول"
            value={form.contactPersonName}
            onChange={(e) => updateField("contactPersonName", e.target.value)}
            className="popup-input popup-input--rect"
          />
          <div className="popup-form-row">
            <input
              type="tel"
              placeholder="الموبايل"
              value={form.mobile}
              onChange={(e) => updateField("mobile", e.target.value)}
              className="popup-input popup-input--rect"
              style={{ marginBottom: 0, flex: 1 }}
            />
            <input
              type="tel"
              placeholder="التليفون"
              value={form.phoneNumber}
              onChange={(e) => updateField("phoneNumber", e.target.value)}
              className="popup-input popup-input--rect"
              style={{ marginBottom: 0, flex: 1 }}
            />
          </div>
          <input
            type="tel"
            placeholder="الخط الساخن"
            value={form.hotline}
            onChange={(e) => updateField("hotline", e.target.value)}
            className="popup-input popup-input--rect"
          />
          <button onClick={onSubmit} className="popup-btn-primary">
            تأكيد بيانات المركز
          </button>
        </div>
      </div>
    </div>
  );
};
